import { render, staticRenderFns } from "./AbscessScarringAndPericarditisAttachmentsTable.vue?vue&type=template&id=f338f2a2&scoped=true&"
import script from "./AbscessScarringAndPericarditisAttachmentsTable.vue?vue&type=script&lang=ts&"
export * from "./AbscessScarringAndPericarditisAttachmentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./AbscessScarringAndPericarditisAttachmentsTable.vue?vue&type=style&index=0&id=f338f2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f338f2a2",
  null
  
)

export default component.exports